import { mapGetters, mapActions, mapMutations } from 'vuex'
import * as fnandoCpf from '@fnando/cpf'

export default {
  data () {
    return {
      rules: {
        cpf: (value) => this.validatorCpf(value) || 'Insira um valor válido e tente novamente'
      },
      cpf: '',
      isLoading: false,
      pagination: {},
      headers: [
        { text: 'Habilitar', align: 'left', sortable: false },
        { text: 'Descrição', align: 'left', sortable: false }
      ],
      rowsPerPage: [10, 20, 30]
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterBlacklistCpf',
      'getterSelectedBlacklistCpf'
    ])
  },
  watch: {
    pagination: {
      handler () {
        this.getAllBlacklistCpf()
      },
      deep: true
    }
  },
  mounted () {
    this.getAllBlacklistCpf()
  },
  beforeDestroy () {
    this.CLEAR_BLACKLIST_CPF_STORE()
  },
  methods: {
    ...mapActions([
      'actionGetAllBlacklistCpf',
      'actionAddBlacklistCpf',
      'actionEditBlacklistCpf'
    ]),
    ...mapMutations([
      'SET_SELECTED_BLACKLIST_CPF',
      'CLEAR_BLACKLIST_CPF_STORE'
    ]),
    validatorCpf () {
      let message = false

      if (fnandoCpf.isValid(this.cpf)) {
        message = true
      }

      return message
    },
    getAllBlacklistCpf () {
      const params = {
        idClient: this.getterAccount.idClient,
        page: this.pagination.page
      }

      this.isLoading = true

      this.actionGetAllBlacklistCpf(params)
        .then(() => {
          this.pagination.totalItems = this.getterBlacklistCpf.totalResults

          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    onClickMainButton () {
      if (Object.keys(this.getterSelectedBlacklistCpf).length === 0) {
        this.isLoading = true
        this.addBlacklistCpf()
      } else {
        this.isLoading = true
        this.editBlacklistCpf()
      }
    },
    addBlacklistCpf () {
      if (this.validatorCpf()) {
        const params = {
          idClient: this.getterAccount.idClient,
          cpf: this.cpf,
          active: true
        }

        this.actionAddBlacklistCpf(params)
          .then(() => {
            this.cleanForm()

            this.isLoading = false

            this.sendToast({
              text: 'CPF inserido com sucesso na base de dados.',
              type: 'success'
            })

            this.getAllBlacklistCpf()
          })
          .catch((response) => {
            if (response.status === 409) {
              this.sendToast({
                text: 'CPF informado ja está cadastrado na base de dados.',
                type: 'warning'
              })
            } else {
              this.sendToast({
                text: 'Erro ao cadastrar CPF na base de dados. Tente novamente mais tarde.',
                type: 'danger'
              })
            }
            this.isLoading = false
          })
      } else {
        this.sendToast({
          text: 'CPF informado é inválido! Verifique e tente novamente',
          type: 'warning'
        })
      }
    },
    editBlacklistCpf (item) {
      this.isLoading = true

      this.actionEditBlacklistCpf(item)
        .then(() => {
          this.sendToast({
            text: 'Alteração efetuada com sucesso!',
            type: 'success'
          })

          this.isLoading = false
        })
        .catch(() => {
          this.sendToast({
            text: 'Alteração não efetuada. Tente novamente mais tarde.',
            type: 'danger'
          })

          this.getAllBlacklistCpf()

          this.isLoading = false
        })
    },
    cleanForm () {
      this.cpf = ''
      this.SET_SELECTED_BLACKLIST_CPF()
    }
  }
}
